import { PARTNER_WHATSAPP_ATTENTION_META } from "../constants/partnerWhatsappMonitoringConstants";
import {
  buildPartnerWhatsappConversationHref,
  buildPartnerWhatsappDealerHealthHref,
} from "../constants/partnerWhatsappMonitoringConstants";

const EMPTY_TOTALS = Object.freeze({
  brokeredLeads: 0,
  buyerConfirmed: 0,
  dealerAlertsSent: 0,
  dealerAccepted: 0,
  dealerPassed: 0,
  handoffsCompleted: 0,
  manualOutreachRequired: 0,
  failedSends: 0,
});

const EMPTY_RATES = Object.freeze({
  buyerConfirmationRate: 0,
  dealerAcceptRate: 0,
  handoffCompletionRate: 0,
});

const DEFAULT_FUNNEL = Object.freeze([
  { key: "submitted", label: "Submitted", count: 0 },
  { key: "buyer_confirmed", label: "Buyer confirmed", count: 0 },
  { key: "dealer_alerted", label: "Dealer alerted", count: 0 },
  { key: "dealer_accepted", label: "Dealer accepted", count: 0 },
  { key: "handoff_completed", label: "Handoff completed", count: 0 },
]);

export function formatPartnerWhatsappRate(value) {
  if (value == null || Number.isNaN(Number(value))) {
    return "—";
  }
  return `${Number(value)}%`;
}

export function formatPartnerWhatsappCount(value) {
  if (value == null || Number.isNaN(Number(value))) {
    return "—";
  }
  return Number(value).toLocaleString();
}

export function mapNeedsAttentionItem(item = {}, { conversationsPath, dealerHealthPath } = {}) {
  const meta = PARTNER_WHATSAPP_ATTENTION_META[item.id] || {};
  const count = item.count ?? 0;
  const label =
    item.label ||
    meta.label ||
    (count > 0 ? `${count} item(s) need attention` : "Needs attention");
  const message = item.message || label;
  const dealerHealthStatus = item.dealerHealthStatus || meta.dealerHealthStatus;
  const route =
    item.route ||
    (dealerHealthPath && dealerHealthStatus
      ? buildPartnerWhatsappDealerHealthHref(dealerHealthPath, { status: dealerHealthStatus })
      : conversationsPath && item.filter
        ? buildPartnerWhatsappConversationHref(conversationsPath, item.filter)
        : null);

  return {
    id: item.id || label,
    severity: item.severity || "warning",
    label,
    message,
    count,
    filter: item.filter || null,
    route,
    comingSoon: !route,
  };
}

export function normalizePartnerWhatsappSummary(body = {}, options = {}) {
  const totals = { ...EMPTY_TOTALS, ...(body.totals || {}) };
  const rates = { ...EMPTY_RATES, ...(body.rates || {}) };
  const funnel = Array.isArray(body.funnel) && body.funnel.length ? body.funnel : [...DEFAULT_FUNNEL];
  const needsAttention = (body.needsAttention || []).map((entry) =>
    mapNeedsAttentionItem(entry, options)
  );

  return {
    success: body.success !== false,
    range: body.range === "30d" ? "30d" : "7d",
    generatedAt: body.generatedAt || null,
    dealerScopeCount: body.dealerScopeCount ?? 0,
    totals,
    rates,
    funnel,
    needsAttention,
    statusCounts: Array.isArray(body.statusCounts) ? body.statusCounts : [],
    redactionPolicyVersion: body.redactionPolicyVersion || null,
  };
}

export function isPartnerWhatsappSummaryEmpty(summary) {
  return (summary?.totals?.brokeredLeads || 0) === 0;
}

export function partnerWhatsappSummaryContainsSensitiveFields(summary) {
  const serialized = JSON.stringify(summary || {});
  const sensitivePatterns = [
    /rawPayload/i,
    /claimToken/i,
    /apiKey/i,
    /x-api-key/i,
    /leadBrokerApiKey/i,
  ];
  return sensitivePatterns.some((pattern) => pattern.test(serialized));
}
